/**
 *
 */
export const LOD_12 = '12';
/**
 *
 */
export const LOD_22 = '22';

/**
 *
 */
export const COORD_WGS84 = 'WGS84';
/**
 *
 */
export const COORD_RD = 'NL_RD';

/**
 *
 * @returns
 */
export const getLODSuffix = (selectedGLBVersion) => {
  switch (selectedGLBVersion) {
    case LOD_12:
      return '_22';
    case LOD_22:
      return '_12';
  }
  return '_12';
};

/**
 *
 * @returns
 */
export const formatCOORDstring = (coordConst) => {
  switch (coordConst) {
    case COORD_WGS84:
      return 'WGS84';
    case COORD_RD:
      return 'RD';
  }
};

/**
 *
 * @returns
 */
export const formatLODString = (lodConst) => {
  switch (lodConst) {
    case LOD_12:
      return '1.2';
    case LOD_22:
      return '2.2';
  }
  return '1.2';
};

/**
 *
 * @returns
 */
export const handleError = (error, dispatch) => {
  let errorMessage = 'Something went wrong';

  console.log('error', error, error.response);

  if (error.response && error.response.message) {
    errorMessage = error.response.message;
  }

  return errorMessage;
};

/**
 * Function Use
 * console.log(findNestedObj(input, 'id', '1'));
 * @returns
 */
export function findNestedObj(entireObj, keyToFind, valToFind) {
  let foundObj;
  JSON.stringify(entireObj, (_, nestedValue) => {
    if (nestedValue && nestedValue[keyToFind] === valToFind) {
      foundObj = nestedValue;
    }
    return nestedValue;
  });
  return foundObj;
}

/**
 *
 */
export const logDebug = (...args) => {
  //@ts-ignore
  if (import.meta.env.NODE_ENV !== 'production') {
    //console.trace();
    console.log(...args);
  }
};

/**
 *
 */
export const logTrace = (...args) => {
  //@ts-ignore
  if (import.meta.env.NODE_ENV !== 'production') {
    //console.trace();
    console.trace(...args);
  }
};

/**
 *
 * @returns
 */
export const logError = (...args) => console.log(...args);

/**
 *
 * @returns
 */
export const logWarn = (...args) => console.warn(...args);

/**
 *
 */
export const downloadFromUrl = (uri, name) => {
  const link = document.createElement('a');
  link.download = name;
  // 'data:' + contentType + ',' + encodeURIComponent(JSON.stringify(objectData));
  link.href = uri;
  link.target = '_blank';
  link.rel = 'noopener noreferrer'; // security best practice
  document.body.appendChild(link);
  // link.target = '_blank'
  link.click();
  document.body.removeChild(link);
};

/**
 *
 * @returns
 */
export const isValidEmail = (email) => {
  // const re =
  //   /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/
  const re = /^[A-Za-z0-9._%+-]+@([A-Za-z0-9-]+\.)+([A-Za-z0-9]{2,4})/gm;
  return re.test(email);
};

/**
 *
 * @returns
 */
export const getAccessRight = (rights) => {
  let label = '';
  switch (rights) {
    case 'V':
      label = 'View Only';
      break;
    case 'U':
      label = 'View and download';
      break;
    case 'E':
      label = 'Full - Edit, View and Download';
      break;
    case 'A':
      label = 'Admin';
      break;
    case 'S':
      label = 'Supplier';
      break;
    default:
      break;
  }
  return label;
};

/**
 *
 * @returns
 */
export const isValidDomain = (domain) => {
  const re =
    // eslint-disable-next-line no-useless-escape
    /^(?:!https?:|s?!ftps?:)?((?!www\.))(?:(?:(?:[a-zA-z\-]+)\:\/{1,3})?(?:[a-zA-Z0-9])(?:[a-zA-Z0-9\-\.]){1,61}(?:\.[a-zA-Z]{2,})+|\[(?:(?:(?:[a-fA-F0-9]){1,4})(?::(?:[a-fA-F0-9]){1,4}){7}|::1|::)\]|(?:(?:[0-9]{1,3})(?:\.[0-9]{1,3}){3}))(?:\:[0-9]{1,5})?$/gm;
  if (domain.includes('http://') || domain.includes('https://')) {
    return false;
  }
  return re.test(domain);
};
/**
 *
 * @returns
 */
export const isValidIntNumber = (num) => {
  return Number.isInteger(num) && num <= 2147483647;
};

/**
 *
 */
export const copyToClipboard = (text) => {
  var textField = document.createElement('textarea');
  textField.innerText = text;
  document.body.appendChild(textField);
  textField.select();
  document.execCommand('copy');
  textField.remove();
};

/**
 *
 * @returns
 */
export const isValidDiscount = (num) => {
  const reg = /(^100(\.0{1,2})?$)|(^([1-9]([0-9])?|0)(\.[0-9]{1,2})?$)/gm;
  if (num === '') {
    return true;
  }
  return reg.test(num);
};

/**
 *
 */
export const convertRadianToDegree = (value) => {};

/**
 *
 * @returns
 */
export const convertDegreeToRadian = (value) => (value * Math.PI) / 180;

/**
 *
 * @returns
 */
export const checkNan = (data) => {
  if (isNaN(data)) {
    return 0;
  }
  return Number(data);
};

/**
 *
 * @returns
 */
export const dateToGimString = (date) => {
  return `${date?.getFullYear()}-${String(date?.getMonth() + 1).padStart(
    2,
    '0'
  )}-${String(date?.getDate()).padStart(2, '0')}`;
};

/**
 *
 * @returns
 */
export const getUnitLongName = (unit) => {
  switch (unit) {
    case 'Mm':
      return 'megametre';
    case 'mm':
      return 'millimetre';
    case 'nm':
      return 'nanometer';
    case 'µm':
      return 'micrometer';
    case 'inch':
      return 'inch';
    case 'm':
      return 'meter';
    case 'ft':
      return 'feet';
    case 'km':
      return 'kilometer';
    case 'mile':
      return 'mile';
    default:
      return null;
  }
};
